import { z } from "zod";
export const ClientWorkspaceBrandingV1Schema = z.object({ schemaVersion: z.literal("client-workspace-branding.v1.0"), requirementId: z.literal("CW-001"), ok: z.boolean() }).strict();
//# sourceMappingURL=client-workspace-branding.js.map